import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getAnswersForQuestions } from 'gqlQueries/promoScoreCard';
import { client } from 'services/apolloInit';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { promoScoreCardQuestionTable } from 'parser/promoScoreCardParser';

const errorMessage: string = 'Something went wrong!';

function useFetchAllQuestions() {
    const { appConfig } = useContext(UserContext);
    const promoScoreCardConfig = getConfig('promoScoreCard', appConfig);
    const [error, setError] = useState<null | string>(null);
    const [promoScoreCardTable, setPromoScoreCardTable] = useState();
    const [allQuestionAndLoading, setAllQuestionAndLoading] = useState<any | null>(() => {
        let initialValue: any = {};
        promoScoreCardConfig.questionsNo.forEach((question: any) => {
            initialValue[question] = { data: [], loading: true, errorMessage: '' };
        });
        return initialValue;
    });
    const variableRef = useRef<any>(null);
    function fetchAllQuestions(variables: any) {
        variableRef.current = variables;
        const temp: any = { ...allQuestionAndLoading };
        for (let que in temp) {
            temp[que].data = [];
            temp[que].loading = true;
        }
        setAllQuestionAndLoading(temp);
        // setAllQuestionAndLoading((oldData: any) => {
        //     for (let que in oldData) {
        //         oldData[que].loading = true;
        //     }
        //     return oldData;
        // });
        promoScoreCardConfig.questionsNo.forEach((questionKey: any) => {
            client
                .query({
                    query: getAnswersForQuestions,
                    variables: {
                        ...variables,
                        questionKey: questionKey,
                    },
                    fetchPolicy: 'cache-first',
                })
                .then((question: any) => {
                    setAllQuestionAndLoading((oldData: any) => ({
                        ...oldData,
                        [questionKey]: {
                            data: question.data.getAnswersForQuestions,
                            loading: question.loading,
                            errorMessage: '',
                        },
                    }));
                })
                .catch((err: any) => {
                    setAllQuestionAndLoading((oldData: any) => ({
                        ...oldData,
                        [questionKey]: { data: [], loading: false, errorMessage: err },
                    }));
                });
        });
    }
    useEffect(() => {
        setPromoScoreCardTable(
            promoScoreCardQuestionTable(
                allQuestionAndLoading,
                promoScoreCardConfig.promoType,
                promoScoreCardConfig.question,
                variableRef.current?.aggregatedItem,
            ),
        );
    }, [allQuestionAndLoading]);

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setAllQuestionAndLoading([]);
        setError(error);
    }

    return {
        error,
        allQuestionAndLoading,
        promoScoreCardTable,
        fetchAllQuestions: (variables: any) => {
            fetchAllQuestions(variables);
        },
    };
}

export { useFetchAllQuestions };
